/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { APP_INITIALIZER, NgModule } from "@angular/core";
import { OAuthModule } from "angular-oauth2-oidc";
import { AuthenticationService } from "./authentication.service";

export function initAuth(
  authenticationService: AuthenticationService,
): () => void {
  return () =>
    new Promise<void>((resolve) => {
      authenticationService.initialize().then((isAuthenticated) => {
        if (isAuthenticated) {
          resolve();
        }
      });
    });
}

@NgModule({
  imports: [OAuthModule.forRoot()],
  providers: [
    AuthenticationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthenticationService],
      multi: true,
    },
  ],
})
export class AuthenticationModule {}
